export default {
  setOffers(state, offers) {
    state.offers = offers;
  },
  setOrderBumpOffers(state, orderBumpOffers) {
    state.orderBumpOffers = orderBumpOffers;
  },
  setOffer(state, offer) {
    state.offer = offer;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
